import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { sdk } from '@/services/sdk';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { toast } from 'sonner';

export const route = { path: '/jobs/new', layout: 'owner', access: "profile === 'Agent_c'" };

export default function JobNew() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ Name: '', service_c: 'Air conditioning', customerName_c: '', phone_c: '', status_c: 'Pending', scheduledAt_c: '', address_c: '', notes_c: '' });
  const change = (key) => (event) => setForm((old) => ({ ...old, [key]: event.target.value }));
  async function save(event) {
    event.preventDefault();
    setSaving(true);
    try {
      const res = await sdk.table('jobs_c').create({ ...form, scheduledAt_c: new Date(form.scheduledAt_c).toISOString() });
      if (res.messages?.length) toast.error(res.messages[0]);
      if (!res.data?.length) return;
      toast.success('Service job created');
      navigate('/jobs');
    } catch (error) {
      toast.error(error.message || 'Could not create job');
    } finally {
      setSaving(false);
    }
  }
  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <Link to="/jobs" className="inline-flex items-center gap-2 text-sm font-semibold text-muted-foreground hover:text-foreground">← Back to jobs</Link>
      <div><p className="text-xs font-bold uppercase tracking-[0.18em] text-muted-foreground">New booking</p><h1 className="mt-2 font-heading text-3xl font-bold">Create a service job</h1><p className="mt-2 text-sm text-muted-foreground">Capture the customer, service type, visit window and location before dispatch.</p></div>
      <form onSubmit={save} className="space-y-6 rounded-2xl border border-border bg-card p-5 shadow-sm sm:p-7">
        <div className="grid gap-5 sm:grid-cols-2">
          <Field label="Job title" required><Input required value={form.Name} onChange={change('Name')} placeholder="e.g. AC not cooling" /></Field>
          <Field label="Service category" required><select required value={form.service_c} onChange={change('service_c')} className="h-10 rounded-md border border-input bg-background px-3 text-sm">{['Air conditioning','Plumbing','Electrical','Appliance repair','Water purifier','Other'].map(x=><option key={x}>{x}</option>)}</select></Field>
          <Field label="Customer name" required><Input required value={form.customerName_c} onChange={change('customerName_c')} placeholder="Customer full name" /></Field>
          <Field label="Phone number"><Input type="tel" value={form.phone_c} onChange={change('phone_c')} placeholder="+91…" /></Field>
          <Field label="Scheduled visit" required><Input type="datetime-local" required value={form.scheduledAt_c} onChange={change('scheduledAt_c')} /></Field>
          <Field label="Initial status" required><select required value={form.status_c} onChange={change('status_c')} className="h-10 rounded-md border border-input bg-background px-3 text-sm">{['Pending','Assigned','In progress','Completed','Cancelled'].map(x=><option key={x}>{x}</option>)}</select></Field>
          <div className="sm:col-span-2"><Field label="Service address" required><Input required value={form.address_c} onChange={change('address_c')} placeholder="Street, area, town" /></Field></div>
          <div className="sm:col-span-2"><Field label="Job notes"><Textarea value={form.notes_c} onChange={change('notes_c')} placeholder="Symptoms, access notes, tools or parts…" rows={4} /></Field></div>
        </div>
        <div className="flex flex-wrap justify-end gap-3 border-t border-border pt-5"><Button type="button" variant="outline" asChild><Link to="/jobs">Cancel</Link></Button><Button type="submit" disabled={saving}>{saving ? 'Saving job…' : 'Create service job'}</Button></div>
      </form>
    </div>
  );
}
function Field({ label, required, children }) { return <div className="grid gap-2"><Label>{label}{required ? ' *' : ''}</Label>{children}</div>; }
